import { Box, Card, Container, MenuItem, TextField, Typography } from '@mui/material';
import 'leaflet/dist/leaflet.css';
import Iconify from 'src/components/iconify';
import { fDate, formatPrice } from 'src/utils/format-time';
import imageIcon from '../../../assets/images/imageIcon.png';
import Image from 'src/components/image';
import BeforeAfterModal from './before-after-modal';
import { useBoolean } from 'src/hooks/use-boolean';
export default function ListCard({ item }) {
  const logoPath = '/logo/logo2.png';
  const open = useBoolean();
  return (
    <>
      <Card elevation={3} sx={{ width: '100%', border: '1px solid #4CBB17' }}>
        <Box display="flex">
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            sx={{
              width: '25%',
              display: { xs: 'none', sm: 'flex' }, // Hide on extra-small screens
            }}
          >
            <img height={50} src={logoPath} alt="logo" />
          </Box>
          <Box sx={{ background: '#F6F6F6', width: { xs: '100%', sm: '75%' } }} p={2}>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Box>
                <Box display="flex">
                  <Typography fontSize={16} variant="p" fontWeight="bold" color="#68686880">
                    Job #:
                  </Typography>
                  <Typography ml={1} fontWeight="bold" fontSize={16} variant="p" color="black">
                    {item?.jobNumber}
                  </Typography>
                </Box>
                <Box mt={1} display="flex">
                  <Typography fontSize={16} variant="p" fontWeight="bold" color="#68686880">
                    Price:
                  </Typography>
                  <Typography
                    position="relative"
                    ml={1}
                    fontWeight="bold"
                    fontSize={16}
                    variant="p"
                    color="black"
                  >
                    <Iconify
                      style={{
                        height: '18px',
                        width: '17px',
                        cursor: 'pointer',
                        color: 'black',
                        position: 'relative',
                        top: '4px',
                        left: '-5px',
                      }}
                      icon="mdi:dollar"
                    />
                    <Box ml={-1} component="span">
                      {formatPrice(item?.price)}
                    </Box>
                  </Typography>
                </Box>
                <Box mt={1} display="flex">
                  <Typography fontSize={16} variant="p" fontWeight="bold" color="#68686880">
                  Lead Code:
                  </Typography>
                  <Typography
                    position="relative"
                    ml={1}
                    fontWeight="bold"
                    fontSize={16}
                    variant="p"
                    color="black"
                  >
                    {item?.leadCode || 'N/A'}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Box display="flex">
                  <Typography fontSize={16} variant="p" fontWeight="bold" color="#68686880">
                    Date:
                  </Typography>
                  <Typography ml={1} fontSize={16} variant="p" fontWeight="bold" color="black">
                    {fDate(item?.installationDate)}
                  </Typography>
                </Box>

                <Box mt={1} display="flex">
                  <Typography fontSize={16} variant="p" fontWeight="bold" color="#68686880">
                    Sales Rep:
                  </Typography>
                  <Typography ml={1} fontSize={16} variant="p" fontWeight="bold" color="black">
                    {item?.rep || item?.userName}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box mt={1} display="flex" gap={3}>
              <Box>
                <Typography fontSize={16} variant="p" fontWeight="bold" color="#68686880">
                  Address:
                </Typography>
                <Typography ml={1} fontSize={16} variant="p" fontWeight="bold" color="black">
                  <Box
                    component="span"
                    sx={{
                      filter: 'blur(4px)',
                      display: 'inline',
                    }}
                  >
                    {item?.streetName?.substring(0, 3) || item?.address?.streetName?.substring(0, 3)}
                  </Box>
                  {item?.streetName?.substring(3) || item?.address?.streetName?.substring(3)}
                  <Box component="span">
                    , {item.city || item?.address?.city}, {item.state || item?.address?.state}, {item.zip || item?.address?.zip}
                  </Box>
                </Typography>
              </Box>
              {item?.images?.beforeImages?.length > 0 && item?.images?.beforeImages?.length > 0 && (
                <Box
                  sx={{
                    width: 25,
                    height: 20,
                    cursor: 'pointer',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  onClick={() => open.onTrue()}
                >
                  <img
                    height="100%"
                    width="100%"
                    src={imageIcon}
                    alt="imageIcon"
                    style={{ objectFit: 'contain' }}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Card>

      <BeforeAfterModal open={open.value} item={item} onClose={() => open.onFalse()} />
    </>
  );
}
